import * as helpers from './helpers'

const defaultListReducerForDzeramaUdensSatecesBaseini = helpers.createListReducerWithMapClicking({
    listViewName: 'dzerama_udens_sateces_baseins_list',
    actionsName: 'dzeramaUdensSatecesBaseini',
    mapIdName: 'dzerama_udens_sateces_baseini_saraksts',
    layerIdName: 'dzeramaUdensSatecesBaseini'
})
export const dzeramaUdensSatecesBaseini = (state = helpers.listGetInitialState(), { type, payload, reqId, mapId, layerId }) => {
    return defaultListReducerForDzeramaUdensSatecesBaseini({ state, type, payload, reqId, mapId, layerId })
}

const defaultEditReducerForDzeramaUdensSatecesBaseins = helpers.createEditReducer({ editViewName: 'dzerama_udens_sateces_baseins_view', actionsName: 'dzeramaUdensSatecesBaseins' })
export const dzeramaUdensSatecesBaseins = (stateFirst = helpers.editWithGeometryInitialState(), { type, payload, mapId, layerId }) => {
    const state = defaultEditReducerForDzeramaUdensSatecesBaseins({ state: stateFirst, type, payload, mapId, layerId })

    switch (type) {
        case 'dzerama_udens_sateces_baseins_clear':
            return helpers.editWithGeometryInitialState()
        case 'dzerama_udens_sateces_baseins_selected':
            const selectedBaseins = payload.isSelect ? payload.id : null
            return {
                ...state,
                selectedBaseins
            }
        case 'MAP_clickedOutsideFeature':
            if (mapId === 'dzerama_udens_sateces_baseins_kartina') {
                return {
                    ...state,
                    selectedBaseins: null,
                }
            } else {
                return state
            }
        case 'MAP_clickedFeature':
            if (mapId === 'dzerama_udens_sateces_baseins_kartina') {
                return {
                    ...state,
                    selectedBaseins: payload.id,
                }
            }
            return state
        case 'dzeramaUdensSatecesBaseins_update_aizsargjosla':
            if (!state.selectedItem || !state.selectedItem.udens_ieguves_vietas) return state
            return {
                ...state,
                selectedItem: {
                    ...state.selectedItem,
                    udens_ieguves_vietas: state.selectedItem.udens_ieguves_vietas.map(uiv =>
                        uiv.urbumi_id === payload.urbumi_id
                            ? { ...uiv, [payload.field]: payload.value }
                            : uiv
                    )
                }
            }
        default:
            return state
    }
}


const defaultEditReducerForVisparigaInfo = helpers.createEditReducer({
    editViewName: 'dzerama_udens_sateces_baseins_vispariga_info_view',
    actionsName: 'dzeramaUdensSatecesBaseinsVisparigaInfo'
})
export const dzeramaUdensSatecesBaseinsVisparigaInfo = (state = helpers.editGetInitialState(), { type, payload }) => {
    switch (type) {
        case 'dzerama_udens_sateces_baseins_clear':
            return helpers.editGetInitialState()
        default:
            return defaultEditReducerForVisparigaInfo({ state, type, payload })
    }
}

const defaultEditReducerForZemesLietojums = helpers.createEditReducer({
    editViewName: 'dzerama_udens_sateces_baseins_zemes_lietojums_view',
    actionsName: 'dzeramaUdensSatecesBaseinsZemesLietojums'
})
export const dzeramaUdensSatecesBaseinsZemesLietojums = (state = helpers.editGetInitialState(), { type, payload }) => {
    switch (type) {
        case 'dzerama_udens_sateces_baseins_clear':
            return helpers.editGetInitialState()
        default:
            return defaultEditReducerForZemesLietojums({ state, type, payload })
    }
}

const defaultListReducerForSituacija = helpers.createListReducerWithMapClicking({
    listViewName: 'dzur_aktuala_situacija_view',
    actionsName: 'dzur_aktuala_situacija',
    mapIdName: 'dzerama_udens_sateces_baseins_kartina',
    layerIdName: 'dzur_aktuala_situacija'
})

export const dzur_aktuala_situacija = (
    state = helpers.listGetInitialState(),
    { type, payload, reqId, mapId, layerId }
) => {
    const base = defaultListReducerForSituacija({ state, type, payload, reqId, mapId, layerId });

    switch (type) {
        case 'dzur_aktuala_situacija_view_list_success':
            // izvelkam visus riska objektus no kategorijām
            return {
                ...base,
                expandedList: base.list.flatMap(k => (k.riska_objekti || []))
            };
        default:
            return base;
    }
};

// riska objektu kategorijas reducers

const defaultListReducerForRiskaKategorijas = helpers.createListReducer({ listViewName: 'riska_objektu_kategorijas_edit', actionsName: 'riskaObjektuKategorija' })
const defaultEditReducerForRiskaKategorijas = helpers.createEditReducer({ editViewName: 'riska_objektu_kategorijas_edit', actionsName: 'riskaObjektuKategorija' })

export const riskaObjektuKategorijas = (state = helpers.listEditGetInitialState(), { type, payload, reqId }) => {

    const stateAfterList = defaultListReducerForRiskaKategorijas({ state, type, payload, reqId })
    return defaultEditReducerForRiskaKategorijas({ state: stateAfterList, type, payload, reqId })
}

// riska novertejumi

const defaultListReducerForRiskaNovertejumi = helpers.createListReducer({
    listViewName: 'riska_novertejumi_list',
    actionsName: 'riskaNovertejumi'
})

const defaultEditReducerForRiskaNovertejumi = helpers.createEditReducer({
    editViewName: 'riska_novertejumi_view',
    actionsName: 'riskaNovertejums'
})

const defaultListReducerForRiskaNovertejumuObjekti = helpers.createListReducer({
    listViewName: 'riska_novertejuma_objekti_view',
    actionsName: 'riskaNovertejumuObjekti'
})

export const riskaNovertejumi = (state = { ...helpers.listGetInitialState(), objektiList: [], selectedItem: null, selectedObjektId: null }, { type, payload, reqId, mapId, layerId }) => {
    const listState = defaultListReducerForRiskaNovertejumi({ state, type, payload, reqId })
    const editState = defaultEditReducerForRiskaNovertejumi({ state: listState, type, payload, reqId })
    const objektiState = defaultListReducerForRiskaNovertejumuObjekti({ state: editState, type, payload, reqId })

    switch (type) {
        case 'riska_novertejums_selected':
            return {
                ...objektiState,
                selectedId: payload
            }
        case 'riska_novertejuma_objekti_view_list_success': {
            const kategorijas = payload.rows || payload || []
            return {
                ...objektiState,
                list: state.list,
                objektiList: kategorijas,
                objektiExpandedList: kategorijas.flatMap(k => (k.riska_objekti || []))
            }
        }
        case 'riska_novertejumi_view_get_success':
            return {
                ...objektiState,
                selectedItem: payload
            }
        case 'riska_novertejumu_objekts_selected':
            return {
                ...objektiState,
                selectedObjektId: payload
            }
        case 'MAP_clickedFeature':
            if (mapId === 'riska_novertejums_detalizeti_karte' && layerId === 'riskaObjekti') {
                return {
                    ...objektiState,
                    selectedObjektId: payload.id
                }
            }
            return objektiState
        case 'MAP_clickedOutsideFeature':
            if (mapId === 'riska_novertejums_detalizeti_karte') {
                return {
                    ...objektiState,
                    selectedObjektId: null
                }
            }
            return objektiState
        default:
            return objektiState
    }
}

const defaultEditReducerForRiskaNovertejumiPamatinfo = helpers.createEditReducer({
    editViewName: 'riska_novertejumi_pamatinfo_view',
    actionsName: 'riskaNovertejumsPamatinfo'
})

export const riskaNovertejumiPamatinfo = (state = helpers.editGetInitialState(), { type, payload, reqId }) => {
    switch (type) {
        case 'riska_novertejumi_view_get_request':
        case 'riska_novertejumi_view_delete_success':
            return { ...state, editable: false }
        default:
            return defaultEditReducerForRiskaNovertejumiPamatinfo({ state, type, payload, reqId })
    }
}

